import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { SitesAreaService } from "../../services/sites-area.service";
import { AngularSvgIconModule } from "angular-svg-icon";
import { NgSelectComponent } from "@ng-select/ng-select";
import { MatDialog } from "@angular/material/dialog";
import { SiteModaleComponent } from "../site-modal/site-modal.component";
import { AreaModaleComponent } from "../area-modal/area-modal.component";
import { Organization } from "@shared/models/organization";
import { Country } from "@shared/models/country";
import { RegionData } from "@shared/models/region-data";
import { Router } from "@angular/router";

@Component({
    standalone: true,
    selector: 'app-sites-area',
    templateUrl: './sites-area.component.html',
    styleUrls: ['./sites-area.component.scss'],
    imports: [CommonModule, FormsModule,MatIconModule, TranslateModule,AngularSvgIconModule,
        NgSelectComponent
    ],
})
export class SitesAreaComponent implements OnInit {
    regions: RegionData[] = [];
    @Input() organizations : Organization[] = [];
    @Input() countries : Country[] = [];
    filteredRegions: RegionData[] = [];
    sites: any[] = [];
    expandedRowIndex: number | null = null;
    constructor(private sitesAreaService: SitesAreaService, private dialogConfirme: MatDialog,
      private router: Router
    ) { }
    ngOnInit(): void {
        this.sitesAreaService.getRegions().subscribe(result => {
            this.regions = result;
            this.filteredRegions = [...this.regions]; 
            this.sitesAreaService.setRegions(this.regions);
        });
      }

    toggleRowDetails(index: number, region: RegionData): void {
      if(region.nbSites === 0) {
        return;
      }
        this.expandedRowIndex = this.expandedRowIndex === index ? null : index;
        this.sitesAreaService.getSitesByRegionId(region.regionId).subscribe( x => {
           this.sites = x;
        });
    }
    onAreaSelect(selectedRegion: RegionData): void {
        if (selectedRegion && selectedRegion.regionId) {
          this.filteredRegions = this.regions.filter(region => region.regionId === selectedRegion.regionId);
        } else {
          this.filteredRegions = [...this.regions];
        }
      }
      onOrganizationSelect(selectedOrganization: Organization): void {
        if (selectedOrganization && selectedOrganization.orgId) {
          this.filteredRegions = this.regions.filter(region => region.orgId === selectedOrganization.orgId);
        } else {
          this.filteredRegions = [...this.regions];
        }
      }
        openPopupSite(siteId: number | null, regionId: number): void {
          const dialogRef = this.dialogConfirme.open(SiteModaleComponent,
            {
              data: { isNew: siteId ? false : true, regionId: regionId , countries : this.countries, regions: this.regions },
              enterAnimationDuration: '0ms',
            },);
          dialogRef.afterClosed().subscribe(() => {
            this.sitesAreaService.getSitesByRegionId(regionId).subscribe( x => {
              this.sites = x;
           });
          });
        }

        openPopupArea(region : RegionData): void {
            const dialogRef = this.dialogConfirme.open(AreaModaleComponent,
              {
                data: { isNew: region?.regionId ? false : true, region:region , organizations : this.organizations },
                enterAnimationDuration: '0ms',
              },);
            dialogRef.afterClosed().subscribe(() => {
                this.sitesAreaService.getRegions().subscribe((regions) => {
                    this.regions = regions;
                    this.filteredRegions = [...this.regions];
                })
            });
          }
          goToDetails(siteId: number): void {
            this.router.navigate(['/settings/site-details'], { queryParams: { siteId } });
          }
}